import { AnfrageListDisplayModel } from "@/api/models/ace/xFound/Portal/Core/CAQ/Models/anfrage-list-display-model";
import { GlobalEnumerationsAceXfoundportalobjekt } from "@/api/models/ace/xFound/Portal/Core/Entities/global-enumerations-ace-xfoundportalobjekt";
import { AnfrageContract } from "../models/abstractions/anfrage.contract";
import { ProjektList } from "../models/projekt-list";
import { ProjektideeList } from "../models/projektidee-list";

export class AnfrageListFactory
{
    public create(anfrage: AnfrageListDisplayModel): AnfrageContract | null
    {
        if (anfrage == undefined)
            return null;

        if (anfrage?.objektTyp == undefined)
            return null;

        switch(anfrage.objektTyp)
        {
            case GlobalEnumerationsAceXfoundportalobjekt.Projekt:
                return new ProjektList(anfrage);
            case GlobalEnumerationsAceXfoundportalobjekt.Projektidee:
                return new ProjektideeList(anfrage);
            default:
                throw new Error("AnfrageFactory: AnfrageListDisplayModel.objektTyp not implemented");
        }
    }
}